<template>
    <div class="product-list flex">
        <div class="product-item" v-for="(item, index) in list" :key="index">
            <div class="img-check-box flex-center" @click.stop="do_toggle_check(item)" v-if="is_show_check">
                <img v-if="item.checked" src="@/static/common/check1.png" alt="" class="img-check check-1" />
                <img v-else src="@/static/common/check0.png" alt="" class="img-check check-0" />
            </div>
            <div class="product-item-info" @click="to_product(item)">
                <div class="img-box">
                    <el-image class="elImg" :src="item.thumb" fit="cover"></el-image>
                    <!-- <shouqing :kucun="goods.kucun" /> -->
                </div>
                <div class="productTitleBox">
                    <div class="productTitle">{{ item.title }}</div>
                    <div class="productMoney">￥{{item.priceSale}}</div>
                </div>
                <!-- <div class="info-box">
                    <div class="title ellipsis-1">
                        {{ item.title }}
                    </div>
                    <div class="price-box flex-center">
                        <div class="sale">
                            <span class="huobi"> {{ vuex_huobi }} </span>
                            <span class="value"> {{ item.priceSale }} </span>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
// import shouqing from "@/components/common/shouqing.vue";

export default {
    name: 'product-list',
    components: {
        // shouqing,
    },
    props: {
        list: {
            type: Array,
            default: function () {
                return []
            },
        },
        is_show_check: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {}
    },
    computed: {
        title1() {
            return this.arrTitle[0] || ''
        },
        title2() {
            return this.arrTitle[1] || ''
        },
    },
    methods: {
        to_product(item) {
            this.$router.push({
                path: '/product-detail',
                query: {
                    id: item.inventoryId,
                },
            })
        },
        do_toggle_check(item) {
            this.$emit('toggle_check', item)
        },
    },
}
</script>

<style scoped lang="less">
.product-item-info {
    height: 100%;
}
.product-list {
    flex-wrap: wrap;

    .product-item {
        position: relative;
        width: 285px;
        background: #ffffff;
        border-radius: 0px 0px 0px 0px;
        margin-right: 35px;
        margin-top: 34px;
        text-align: center;
        border: 1px solid #e5e5e5;
        overflow: hidden;
        cursor: pointer;

        &:nth-child(4n) {
            margin-right: 0;
        }

        &:nth-child(-n + 4) {
            margin-top: 0;
        }

        // &:hover {
        //   .img-box {
        //     img {
        //       transform: scale(1.1);
        //     }
        //   }
        // }

        .img-box {
            width: 285px;
            height: 285px;
            margin: 0 auto 0 auto;
            border-bottom: 1px solid #e5e5e5;
            overflow: hidden;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;

            .elImg {
                width: 202px;
                height: 202px;
                transition: 0.3s;
            }
        }

        .productTitleBox {
            width: 100%;
            padding: 18px;

            &:hover {
                .productTitle {
                    color: #ea3200;
                }
            }

            .productTitle {
                width: 100%;
                font-size: 18px;
                color: #333333;
                line-height: 18px;
                text-align: start;
                margin-bottom: 16px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            .productMoney {
                width: 100%;
                font-weight: bold;
                font-size: 22px;
                color: #ff4d00;
                line-height: 22px;
                text-align: start;
            }
        }

        .info-box {
            width: 100%;
            background: #fff;

            .title {
                text-align: center;
                width: 100%;
                font-weight: 600;
                font-size: 14px;
                color: #000000;
            }

            .price-box {
                margin-top: 5px;

                .sale {
                    span {
                        font-family: OPPOSans, OPPOSans;
                        font-weight: bold;
                        font-size: 12px;
                        color: #ff0000;
                    }
                }

                .market {
                    // text-decoration: line-through;
                    margin-left: 17px;
                    color: #bfbfbf;

                    span {
                        text-decoration: line-through;
                        font-family: OPPOSans, OPPOSans;
                        font-weight: 400;
                        font-size: 12px;
                        color: #bfbfbf;
                    }
                }
            }

            .sku-box {
                min-height: 50px;
                margin-top: 8px;
                flex-wrap: wrap;

                .sku-item {
                    position: relative;
                    padding: 4px 0;
                    width: 50%;
                    text-align: center;
                    font-family: Arial, Arial;
                    font-weight: 400;
                    font-size: 12px;
                    color: #444444;

                    &::after {
                        content: '';
                        position: absolute;
                        bottom: 0;
                        left: 50%;
                        width: 0px;
                        height: 1px;
                        transform: translate(-50%);
                        background: #ccc;
                    }

                    &:hover {
                        &::after {
                            width: 40px;
                        }
                    }
                }
            }

            .btn-box {
                margin-top: 20px;

                .btn-cart {
                    width: 226px;
                    width: 100%;
                    height: 27px;
                    border-radius: 0px 0px 0px 0px;
                    border: 1px solid #4ca5e4;
                    font-family: OPPOSans, OPPOSans;
                    font-weight: bold;
                    font-size: 12px;
                    color: #4ca5e4;

                    &:hover {
                        background: #4ca5e4;
                        color: #fff;
                    }
                }
            }
        }
    }
}

.img-check-box {
    position: absolute;
    z-index: 10;
    left: 18px;
    top: 18px;
    width: 15px;
    height: 15px;
    cursor: pointer;

    .img-check {
        width: 14px;
    }
}

.img-check-box::after {
    content: '';
    position: absolute;
    top: -10px;
    right: -10px;
    bottom: -10px;
    left: -10px;
}
</style>

<style scoped lang="less">
@media screen and (max-width: 1199px) {
    .product-list {
        .flex();
        flex-wrap: wrap;
        justify-content: space-between;

        .item {
            width: calc((100% - 15px) / 2);
            margin: 0;
            margin-right: 0;
            margin-top: 0;
            margin-bottom: 15px;

            text-align: center;
            border: 1px solid #e5e5e5;
            overflow: hidden;

            &:nth-child(4n) {
                margin-right: 0;
            }

            &:nth-child(-n + 4) {
                margin-top: 0;
            }

            &:hover {
                .img-box {
                    img {
                        transform: scale(1.1);
                    }
                }
            }

            .img-box {
                // width: 228px;
                // height: 228px;
                overflow: hidden;
                position: relative;

                img {
                    width: 100%;
                    height: auto;
                    object-fit: cover;
                    transition: 0.3s;
                }
            }

            .info-box {
                width: 100%;
                background: #fff;
                // border: 1px solid #e5e5e5;
                // border-top: none;
                padding: 10px;
            }

            .title {
                text-align: left;
                width: 100%;
                .ellipsis-2();

                font-size: 12px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #222222;
                white-space: normal;
            }

            .baozhiqi {
                margin-top: 10px;
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #ea5959;
            }

            .price-box {
                margin-top: 5px;

                .sale {
                    span {
                        font-family: OPPOSans, OPPOSans;
                        font-weight: bold;
                        font-size: 12px;
                        color: #ff0000;
                    }
                }

                .market {
                    text-decoration: line-through;
                    margin-left: 17px;

                    span {
                        font-family: OPPOSans, OPPOSans;
                        font-weight: 400;
                        font-size: 12px;
                        color: #bfbfbf;
                    }
                }
            }
        }
    }
}
</style>
